module.exports = __webpack_public_path__ + "img/app-store-badge.5e5fa8ba.png";